import { ERouteStopType } from "../../Enum/ERouteStopType"

export class RouteStop {
  sequence: number

  stopType: ERouteStopType

  deliveryId: number

  orderId: number

  latitude: number

  longitude: number

  address: string

  customerName?: string

  distanceFromPreviousKm: number

  constructor(data: Partial<RouteStop> = {}) {
    this.sequence = data.sequence ?? 0

    this.stopType = data.stopType ?? ERouteStopType.Pickup

    this.deliveryId = data.deliveryId ?? -1

    this.orderId = data.orderId ?? -1

    this.latitude = data.latitude ?? 0

    this.longitude = data.longitude ?? 0

    this.address = data.address ?? ""

    this.customerName = data.customerName

    this.distanceFromPreviousKm = Number(data.distanceFromPreviousKm ?? 0)
  }

  isPickup(): boolean {
    return this.stopType === ERouteStopType.Pickup
  }
}
